function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Help-Icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#1373E6",
  strokeWidth: 3,
  cx: 19,
  cy: 19,
  r: 17.5
}), /*#__PURE__*/React.createElement("g", {
  id: "?",
  transform: "translate(13.000000, 9.000000)",
  fill: "#1373E6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.47224594,0 C8.43151412,0 10.0092902,0.542524005 11.2055741,1.62757202 C12.401858,2.71262003 13,4.20576132 13,6.10699588 C13,7.98902606 12.4065678,9.42455418 11.2197034,10.4135802 C10.0328391,11.4026063 8.45977279,11.8971193 6.50050462,11.8971193 L6.38746992,14.1152263 L2.91165282,14.1152263 L2.77035944,9.218107 L4.04199984,9.218107 C5.68100303,9.218107 6.94322387,8.99725652 7.82866237,8.55555556 C8.71410087,8.1138546 9.15682012,7.30727023 9.15682012,6.13580247 C9.15682012,5.29080933 8.91662138,4.61865569 8.4362239,4.11934156 C7.95582641,3.62002743 7.30116709,3.37037037 6.47224594,3.37037037 C5.60564656,3.37037037 4.93214813,3.61042524 4.45175064,4.09053498 C3.97135316,4.57064472 3.73115441,5.23319616 3.73115441,6.0781893 L0.00100923841,6.0781893 C-0.0178298786,4.90672154 0.227078643,3.8600823 0.735734803,2.9382716 C1.24439096,2.01646091 1.99324587,1.2962963 2.98229951,0.777777778 C3.97135316,0.259259259 5.13466863,0 6.47224594,0 Z M4.63543203,21 C3.91954558,21 3.33082318,20.7743484 2.86926481,20.3230453 C2.40770644,19.8717421 2.17692726,19.3100137 2.17692726,18.6378601 C2.17692726,17.9657064 2.40770644,17.4039781 2.86926481,16.9526749 C3.33082318,16.5013717 3.91954558,16.2757202 4.63543203,16.2757202 C5.33247936,16.2757202 5.90707243,16.5013717 6.35921124,16.9526749 C6.81135005,17.4039781 7.03741946,17.9657064 7.03741946,18.6378601 C7.03741946,19.3100137 6.81135005,19.8717421 6.35921124,20.3230453 C5.90707243,20.7743484 5.33247936,21 4.63543203,21 Z",
  id: "Shape"
})));

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help-Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help-Icon.3adc87d5.svg";
export { ForwardRef as ReactComponent };